import { Routes } from '@angular/router';
import { hasSessionGuard } from './_core/session-guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canMatch: [hasSessionGuard],
    children: []
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login'
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth.routes')
        .then(m => m.AUTH_ROUTES)
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.routes')
        .then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'cu',
    loadChildren: () =>
      import('./customer/customer.routes')
        .then(m => m.CUSTOMER_ROUTES)
  },
  
  {
    path: 'pl',
    loadChildren: () =>
      import('./plan-subscription/plan-subscription.routes')
        .then(m => m.CUSTOMER_ROUTES)
  },
  //{
  //  path: 'registration-complete',
  //  loadComponent: () =>
  //    import('./shared/registration-complete/registration-complete')
  //      .then(m => m.RegistrationCompleteComponent)
  //},
  // fallback finale
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./shared/http-errors/unauthorized/unauthorized')
        .then(m => m.Unauthorized)
  },

  // fallback finale
  {
    path: '**',
    loadComponent: () =>
      import('./shared/http-errors/not-found/not-found')
        .then(m => m.NotFoundComponent)
  }
];
